import { render, staticRenderFns } from "./quiz-answer.vue?vue&type=template&id=6fc2ff56&scoped=true&"
import script from "./quiz-answer.vue?vue&type=script&lang=js&"
export * from "./quiz-answer.vue?vue&type=script&lang=js&"
import style0 from "./quiz-answer.vue?vue&type=style&index=0&id=6fc2ff56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc2ff56",
  null
  
)

export default component.exports